<template>
	<the-transition v-bind="$attrs">
		<slot></slot>
	</the-transition>
</template>

<script>
	import { TransitionFade as TheTransition } from '@morev/vue-transitions';

	export default {
		name: 'TransitionFade',
		inheritAttrs: false,
		components: { TheTransition },
	};
</script>
